import React, { useRef, useState } from "react";
import HeadLines from "../CommonComponents/HeadLines";
import useIsUserLoggedIn from "../CustomHooks/useIsUserLoggedIn";
import { isMobile } from "../helperFunc";
import { ExploreOurServicesData } from "./Constant";
import ScrollCard from "./ScrollCard";
import style from "./style.module.css";
import ScrollDeskArrow from "../CommonComponents/ScrollDeskArrow/ScrollDeskArrow";
import { scroll } from "../CommonFunctions/Function";

const ExploreOurServices = ({ showScroll = false }) => {
  const [userLoggedIn] = useIsUserLoggedIn();
  const scrollRef = useRef();
  const [scrollX, setscrollX] = useState(0); // For detecting start scroll postion
  const [scrollEnd, setscrollEnd] = useState(false); // For detecting end of scrolling
  return (
    <div className={!isMobile && !userLoggedIn && "padding-left-right100"}>
      <HeadLines
        className={`font-weight600 margin-bottom16 ${
          isMobile
            ? " margin-left16 padding-top8"
            : " font-size24 line-height28"
        }`}
        text="Explore Our Services"
      />
      <div className="scroll-smooth-behaviour positionRelative">
        <div
          className={`${
            isMobile ? "margin-right16" : "d-flex"
          } scrollHorizontal ${
            style["padding-top18"]
          } scroll-smooth-behaviour  padding-bottom16`}
          ref={scrollRef}
          onScroll={() =>
            showScroll && scroll(setscrollX, scrollRef, setscrollEnd)
          }
        >
          {ExploreOurServicesData.map((item, index) => {
            return (
              <ScrollCard
                data={item}
                index={index}
                showScroll={showScroll}
                isExploreWidget={true}
              />
            );
          })}
        </div>
        {showScroll && (
          <ScrollDeskArrow
            scrollRef={scrollRef}
            scrollEnd={scrollEnd}
            setscrollEnd={setscrollEnd}
            scrollX={scrollX}
            setscrollX={setscrollX}
            leftArrowClassName={style["left-arrow-desktop"]}
            rightArrowClassName={style["right-arrow-desktop"]}
          />
        )}
      </div>
    </div>
  );
};
export default ExploreOurServices;
